var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchWithAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-search",
    stroke: "var(--magnifying-color, currentColor)",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M15.5 13.5 A6 6 0 1 1 10.5 4.5 M16.5 16.5 l3.5 3.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.5, 0.2) scale(0.50)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-stars",
    d: "M19 10.5l1.5-4L24.5 5l-4-1.5L19 -0.5l-1.5 4L13.5 5l4 1.5L19 10.5zm-7.5-1L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 13.5l-1.5 4L13.5 19l4 1.5L19 24.5l1.5-4L24.5 19l-4-1.5L19 13.5z",
    fill: "var(--star-color, currentColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWithAi);
export default __webpack_public_path__ + "static/media/SearchWithAI.3713d5bbec8684c4c3d83b50d33749bf.svg";
export { ForwardRef as ReactComponent };